export default __webpack_public_path__ + "static/media/right_text_selected.31c18579.svg";